import { BORDER_RADIUS_OPTIONS, ClassEnum } from '@/constants/enum';
import React, { useState, useEffect, useRef } from 'react';

interface IProps {
  isDisabled?: boolean;
  buttonContent: React.ReactNode;
  borderRadius?: BORDER_RADIUS_OPTIONS;
  width?: string;
  styles?: {
    button?: React.CSSProperties;
    content?: React.CSSProperties;
    contentItem?: React.CSSProperties;
  };
  color?: string;
  backgroundColor?: string;
  children: React.ReactNode;
}

const Popover = ({ children, ...props }: IProps) => {
  const [isShowContent, setIsShowContent] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
      setIsShowContent(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={popoverRef} className={ClassEnum.Dropdown}>
      <div
        className={ClassEnum.DropdownButton + ' ' + (props.isDisabled ? ClassEnum.Disabled : '')}
        style={{
          borderRadius: props.borderRadius,
          color: props.color,
          backgroundColor: props.backgroundColor,
          ...props.styles?.button,
        }}
        onClick={() => setIsShowContent(!isShowContent)}
      >
        <div>{props.buttonContent}</div>
      </div>
      {isShowContent ? (
        <div
          className={ClassEnum.DropdownContent}
          style={{
            animation: 'dropdown 0.3s',
            borderRadius: props.borderRadius,
            width: props.width,
            color: props.color,
            backgroundColor: props.backgroundColor,
            ...props.styles?.content,
          }}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default Popover;
